// Plan features, shared by the landing page and the pricing page.
// Keep these in line with what the code actually gates (see PremiumLockOverlay).
export const FREE_FEATURES = [
  'Hand-by-hand parsing of full logs',
  'VPIP, PFR and 3-bet for every player',
  'Your top 10 wins and losses',
  'Top 12 showdown hands per player',
  'Ledger settle-ups with share links',
  'Bankroll tracking',
];

export const PREMIUM_FEATURES = [
  'Everything in Free',
  'Every showdown hand, for every player',
  'Raise, 3-bet and full-shows charts',
];

export const PREMIUM_PRICE = 9.99;
